/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PaymentApprovalStatus = {
    CREATED: 'CREATED',
    MODIFIED: 'MODIFIED',
    CANCELLED: 'CANCELLED',
    SUCCEED: 'SUCCEED',
    WAIT_PAYMENT: 'WAIT_PAYMENT'
} as const;
export type PaymentApprovalStatus = typeof PaymentApprovalStatus[keyof typeof PaymentApprovalStatus];

